import React from "react"

import classes from "./ShiftCashierSeparator.module.scss"

const ShiftCashierSeparator = () => {
  return (
    <div className={classes["separator"]} />
  )
}

export default ShiftCashierSeparator